// extracted by mini-css-extract-plugin
export default {"overlay":"ThresholdModal-module__overlay__T_K3_","dialog-content":"ThresholdModal-module__dialog-content__WcTyC"};